module.exports = __webpack_public_path__ + "img/small-arrow.e29e0bda.svg";